// extracted by mini-css-extract-plugin
export default {"burgerMenuIcon":"Header_burgerMenuIcon__Ktsaz","header":"Header_header__mvptX"};